import { createFileRoute, Link, redirect } from '@tanstack/react-router'
import { z } from 'zod'
import { ResetPasswordForm } from '@/components/auth/reset-password-form'
import MkdnLogo from '@/components/ui/mkdn-logo'
import { requireGuest } from '@/lib/route-guards'

const search = z.object({
  token: z.string().min(1),
  email: z.string().email().optional(),
})

export const Route = createFileRoute('/reset-password')({
  validateSearch: search,
  beforeLoad: async ({ search }) => {
    await requireGuest()
    if (!search.token) {
      throw redirect({ to: '/forgot-password' })
    }
  },
  component: ResetPasswordPage,
  head: () => ({ meta: [{ title: 'Reset password — mkdn.app' }] }),
})

function ResetPasswordPage() {
  const { token, email } = Route.useSearch()
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <Link to="/" className="flex items-center gap-2 self-center font-medium">
          <MkdnLogo size="lg" />
        </Link>
        <ResetPasswordForm token={token} email={email} />
      </div>
    </div>
  )
}
